import React from "react";
import gsap from "gsap";

const closeNotification = () => {
  gsap.to(".notify", {
    top: "-100%",
    opacity: 0,
    duration: 0.5,
    display: "none",
  });
};

const Notification = () => {
  return (
    <div className="notify">
      <p>
        <strong>Interact: </strong>Click and drag to see the magic of paint
        unfold! 🎨✨
      </p>
      <button onClick={closeNotification}> CLOSE</button>
    </div>
  );
};

export default Notification;
